export default __webpack_public_path__ + "static/media/bb-00008.1a5c7876.png";